import * as Api from '@ViewModels';
import moment from 'moment';
import * as yup from 'yup';
import { IRichContentEditorState } from '../../../../viewmodels/AppViewModels';
import {
	createCustomFormFieldSchema,
	createNotificationSettingsSchema,
	createTagGenerationSettingsSchema,
} from '../shared/validation/schemas';

export const QUESTION_LIMIT = 20;

export const TabValues = {
	Questions: 'Questions',
	Settings: 'Settings',
	Preview: 'Preview',
} as const;

export type TabValues = (typeof TabValues)[keyof typeof TabValues];

export const EVENT_TIME_OPTIONS = [
	{ id: '00:00:00', text: '12:00 AM', dataContext: '00:00:00' },
	{ id: '00:15:00', text: '12:15 AM', dataContext: '00:15:00' },
	{ id: '00:30:00', text: '12:30 AM', dataContext: '00:30:00' },
	{ id: '00:45:00', text: '12:45 AM', dataContext: '00:45:00' },
	{ id: '01:00:00', text: '1:00 AM', dataContext: '01:00:00' },
	{ id: '01:15:00', text: '1:15 AM', dataContext: '01:15:00' },
	{ id: '01:30:00', text: '1:30 AM', dataContext: '01:30:00' },
	{ id: '01:45:00', text: '1:45 AM', dataContext: '01:45:00' },
	{ id: '02:00:00', text: '2:00 AM', dataContext: '02:00:00' },
	{ id: '02:15:00', text: '2:15 AM', dataContext: '02:15:00' },
	{ id: '02:30:00', text: '2:30 AM', dataContext: '02:30:00' },
	{ id: '02:45:00', text: '2:45 AM', dataContext: '02:45:00' },
	{ id: '03:00:00', text: '3:00 AM', dataContext: '03:00:00' },
	{ id: '03:15:00', text: '3:15 AM', dataContext: '03:15:00' },
	{ id: '03:30:00', text: '3:30 AM', dataContext: '03:30:00' },
	{ id: '03:45:00', text: '3:45 AM', dataContext: '03:45:00' },
	{ id: '04:00:00', text: '4:00 AM', dataContext: '04:00:00' },
	{ id: '04:15:00', text: '4:15 AM', dataContext: '04:15:00' },
	{ id: '04:30:00', text: '4:30 AM', dataContext: '04:30:00' },
	{ id: '04:45:00', text: '4:45 AM', dataContext: '04:45:00' },
	{ id: '05:00:00', text: '5:00 AM', dataContext: '05:00:00' },
	{ id: '05:15:00', text: '5:15 AM', dataContext: '05:15:00' },
	{ id: '05:30:00', text: '5:30 AM', dataContext: '05:30:00' },
	{ id: '05:45:00', text: '5:45 AM', dataContext: '05:45:00' },
	{ id: '06:00:00', text: '6:00 AM', dataContext: '06:00:00' },
	{ id: '06:15:00', text: '6:15 AM', dataContext: '06:15:00' },
	{ id: '06:30:00', text: '6:30 AM', dataContext: '06:30:00' },
	{ id: '06:45:00', text: '6:45 AM', dataContext: '06:45:00' },
	{ id: '07:00:00', text: '7:00 AM', dataContext: '07:00:00' },
	{ id: '07:15:00', text: '7:15 AM', dataContext: '07:15:00' },
	{ id: '07:30:00', text: '7:30 AM', dataContext: '07:30:00' },
	{ id: '07:45:00', text: '7:45 AM', dataContext: '07:45:00' },
	{ id: '08:00:00', text: '8:00 AM', dataContext: '08:00:00' },
	{ id: '08:15:00', text: '8:15 AM', dataContext: '08:15:00' },
	{ id: '08:30:00', text: '8:30 AM', dataContext: '08:30:00' },
	{ id: '08:45:00', text: '8:45 AM', dataContext: '08:45:00' },
	{ id: '09:00:00', text: '9:00 AM', dataContext: '09:00:00' },
	{ id: '09:15:00', text: '9:15 AM', dataContext: '09:15:00' },
	{ id: '09:30:00', text: '9:30 AM', dataContext: '09:30:00' },
	{ id: '09:45:00', text: '9:45 AM', dataContext: '09:45:00' },
	{ id: '10:00:00', text: '10:00 AM', dataContext: '10:00:00' },
	{ id: '10:15:00', text: '10:15 AM', dataContext: '10:15:00' },
	{ id: '10:30:00', text: '10:30 AM', dataContext: '10:30:00' },
	{ id: '10:45:00', text: '10:45 AM', dataContext: '10:45:00' },
	{ id: '11:00:00', text: '11:00 AM', dataContext: '11:00:00' },
	{ id: '11:15:00', text: '11:15 AM', dataContext: '11:15:00' },
	{ id: '11:30:00', text: '11:30 AM', dataContext: '11:30:00' },
	{ id: '11:45:00', text: '11:45 AM', dataContext: '11:45:00' },
	{ id: '12:00:00', text: '12:00 PM', dataContext: '12:00:00' },
	{ id: '12:15:00', text: '12:15 PM', dataContext: '12:15:00' },
	{ id: '12:30:00', text: '12:30 PM', dataContext: '12:30:00' },
	{ id: '12:45:00', text: '12:45 PM', dataContext: '12:45:00' },
	{ id: '13:00:00', text: '1:00 PM', dataContext: '13:00:00' },
	{ id: '13:15:00', text: '1:15 PM', dataContext: '13:15:00' },
	{ id: '13:30:00', text: '1:30 PM', dataContext: '13:30:00' },
	{ id: '13:45:00', text: '1:45 PM', dataContext: '13:45:00' },
	{ id: '14:00:00', text: '2:00 PM', dataContext: '14:00:00' },
	{ id: '14:15:00', text: '2:15 PM', dataContext: '14:15:00' },
	{ id: '14:30:00', text: '2:30 PM', dataContext: '14:30:00' },
	{ id: '14:45:00', text: '2:45 PM', dataContext: '14:45:00' },
	{ id: '15:00:00', text: '3:00 PM', dataContext: '15:00:00' },
	{ id: '15:15:00', text: '3:15 PM', dataContext: '15:15:00' },
	{ id: '15:30:00', text: '3:30 PM', dataContext: '15:30:00' },
	{ id: '15:45:00', text: '3:45 PM', dataContext: '15:45:00' },
	{ id: '16:00:00', text: '4:00 PM', dataContext: '16:00:00' },
	{ id: '16:15:00', text: '4:15 PM', dataContext: '16:15:00' },
	{ id: '16:30:00', text: '4:30 PM', dataContext: '16:30:00' },
	{ id: '16:45:00', text: '4:45 PM', dataContext: '16:45:00' },
	{ id: '17:00:00', text: '5:00 PM', dataContext: '17:00:00' },
	{ id: '17:15:00', text: '5:15 PM', dataContext: '17:15:00' },
	{ id: '17:30:00', text: '5:30 PM', dataContext: '17:30:00' },
	{ id: '17:45:00', text: '5:45 PM', dataContext: '17:45:00' },
	{ id: '18:00:00', text: '6:00 PM', dataContext: '18:00:00' },
	{ id: '18:15:00', text: '6:15 PM', dataContext: '18:15:00' },
	{ id: '18:30:00', text: '6:30 PM', dataContext: '18:30:00' },
	{ id: '18:45:00', text: '6:45 PM', dataContext: '18:45:00' },
	{ id: '19:00:00', text: '7:00 PM', dataContext: '19:00:00' },
	{ id: '19:15:00', text: '7:15 PM', dataContext: '19:15:00' },
	{ id: '19:30:00', text: '7:30 PM', dataContext: '19:30:00' },
	{ id: '19:45:00', text: '7:45 PM', dataContext: '19:45:00' },
	{ id: '20:00:00', text: '8:00 PM', dataContext: '20:00:00' },
	{ id: '20:15:00', text: '8:15 PM', dataContext: '20:15:00' },
	{ id: '20:30:00', text: '8:30 PM', dataContext: '20:30:00' },
	{ id: '20:45:00', text: '8:45 PM', dataContext: '20:45:00' },
	{ id: '21:00:00', text: '9:00 PM', dataContext: '21:00:00' },
	{ id: '21:15:00', text: '9:15 PM', dataContext: '21:15:00' },
	{ id: '21:30:00', text: '9:30 PM', dataContext: '21:30:00' },
	{ id: '21:45:00', text: '9:45 PM', dataContext: '21:45:00' },
	{ id: '22:00:00', text: '10:00 PM', dataContext: '22:00:00' },
	{ id: '22:15:00', text: '10:15 PM', dataContext: '22:15:00' },
	{ id: '22:30:00', text: '10:30 PM', dataContext: '22:30:00' },
	{ id: '22:45:00', text: '10:45 PM', dataContext: '22:45:00' },
	{ id: '23:00:00', text: '11:00 PM', dataContext: '23:00:00' },
	{ id: '23:15:00', text: '11:15 PM', dataContext: '23:15:00' },
	{ id: '23:30:00', text: '11:30 PM', dataContext: '23:30:00' },
	{ id: '23:45:00', text: '11:45 PM', dataContext: '23:45:00' },
];

export const DEFAULT_NAME = 'Untitled Survey';

export interface EventRegistrationFormData {
	details: IRichContentEditorState;
	startDate: string | undefined;
	startTime: string | undefined;
	endDate: string | undefined;
	endTime: string | undefined;
	eventName: string;
	guestLimit: number;
	location: string;
	maximumCapacity: number;
	registrationDeadline: Date | null;
	requireDeadline: boolean;
	requireMaximumCapacity: boolean;
	requirePhoneNumber: boolean;
	requireGuestNames: boolean;
	enableRequestAttendeesToRSVP: boolean;
	customForm: {
		name: string;
		fields: Api.IFormField<string>[];
	};
	isPaidEvent: boolean;
	payments: {
		cost: number;
	};
	eventTickets: Api.IEventTicket[];
	ticketSortMode: Api.TicketSortMode;
	timezone: string;
	notificationSettings: {
		isEnabled: boolean;
		additionalRecipients: string[];
	};
	tagGenerationSettings: {
		tagOnCompletion: boolean;
		completionTag: string;
		customFormFieldTagSettings: Api.ICustomFormFieldTagSettings[];
		effectiveCompletionTag?: Api.IAccountTag;
	};
	showOnHomepage: boolean;
	showSurveyName?: boolean;
	surveyForm?: Api.SurveyForm;
	surveyFormVisibilityValidation?: {
		enabled: boolean;
		hasQuestion: boolean;
		hasAllAnswers: boolean;
	}[];
}

export const validationSchema = yup.object({
	details: yup
		.mixed<IRichContentEditorState>()
		.test('has-content', 'Event details are required', value => !!value?.hasContent?.()),
	startDate: yup.string().required('Event date is required'),
	startTime: yup.string().required('Event time is required'),
	endDate: yup.string(),
	endTime: yup.string(),
	eventName: yup.string().required('Event name is required'),
	guestLimit: yup
		.number()
		.typeError('Guest limit must be a number')
		.min(0, 'Guest limit cannot be negative')
		.required('Guest limit is required'),
	location: yup.string().required('Event location is required'),
	maximumCapacity: yup
		.number()
		.min(1, 'Maximum capacity must be at least 1')
		.typeError('Maximum capacity must be a number')
		.when('requireMaximumCapacity', {
			is: true,
			then: schema => {
				return schema.required('Maximum capacity is required');
			},
		}),
	registrationDeadline: yup
		.date()
		.nullable()
		.typeError('Deadline date is required')
		.when('requireDeadline', {
			is: true,
			then: schema => {
				return schema.required('Deadline date is required');
			},
		}),
	requireDeadline: yup.boolean(),
	requireMaximumCapacity: yup.boolean(),
	requirePhoneNumber: yup.boolean(),
	customForm: yup.object({
		name: yup.string(),
		fields: createCustomFormFieldSchema({
			questionLimit: QUESTION_LIMIT,
			requireLabels: true,
		}),
	}),
	isPaidEvent: yup.boolean(),
	payments: yup.object({
		cost: yup.number().test('cost-or-tickets-required', 'Event cost or tickets are required', function (val) {
			const { isPaidEvent, eventTickets } = this.from[1].value as EventRegistrationFormData;

			// If not a paid event, no validation needed
			if (!isPaidEvent) {
				return true;
			}

			// For paid events, check if we have tickets OR a legacy cost
			const hasTickets = eventTickets && eventTickets.length > 0;
			const hasCost = val && val > 0;

			if (hasTickets || hasCost) {
				return true;
			}

			// If using tickets, require at least one ticket
			if (eventTickets !== undefined && eventTickets.length === 0) {
				return this.createError({ message: 'At least one ticket is required for paid events' });
			}

			// Legacy mode: cost must be greater than 0
			return this.createError({ message: 'Event cost is required' });
		}),
	}),
	eventTickets: yup
		.array()
		.of(
			yup.object({
				name: yup.string().required('Ticket name is required'),
				description: yup.string(),
				unitPrice: yup.number().min(1, 'Ticket price must be greater than 0').required('Ticket price is required'),
				maxAllowed: yup.number().min(1, 'Maximum tickets must be at least 1').nullable(),
				attendeeCountPerItem: yup.number().min(1).required(),
				isDefault: yup.boolean(),
			})
		)
		.default([]),
	ticketSortMode: yup
		.mixed<Api.TicketSortMode>()
		.oneOf([
			Api.TicketSortMode.PriceAscending,
			Api.TicketSortMode.PriceDescending,
			Api.TicketSortMode.NameAscending,
			Api.TicketSortMode.NameDescending,
		]),
	notificationSettings: createNotificationSettingsSchema().optional(),
	tagGenerationSettings: createTagGenerationSettingsSchema().optional(),
	showOnHomepage: yup.boolean(),
	showSurveyName: yup.boolean().default(true),
	// SurveyForm — no schema validation needed, validated via surveyFormVisibilityValidation
	surveyForm: yup.mixed().optional(),
	// Per-field conditional visibility validation entries
	// Parallel array matching customForm.fields, used to validate incomplete visibility configs
	surveyFormVisibilityValidation: yup
		.array()
		.of(
			yup
				.object({
					enabled: yup.boolean(),
					hasQuestion: yup.boolean(),
					hasAllAnswers: yup.boolean(),
				})
				.test(
					'conditional-visibility-complete',
					'Please select a question and answer for conditional visibility',
					function (value) {
						if (!value?.enabled) return true;
						if (!value.hasQuestion) {
							return this.createError({ message: 'Please select a question for conditional visibility' });
						}
						if (!value.hasAllAnswers) {
							return this.createError({ message: 'Please select an answer for each conditional visibility row' });
						}
						return true;
					}
				)
		)
		.optional(),
});

export function isValidEventDate(
	dateValues: Pick<EventRegistrationFormData, 'startDate' | 'startTime' | 'endDate' | 'endTime'>
) {
	const { startDate, startTime, endDate, endTime } = dateValues;
	if (!startDate || !startTime) {
		return false;
	}
	if (endDate && endDate !== startDate && (!startTime || !endTime)) {
		return false;
	}
	if (
		(endDate === startDate || !endDate) &&
		endTime &&
		moment(startTime, 'HH:mm:ss').isSameOrAfter(moment(endTime, 'HH:mm:ss'))
	) {
		return false;
	}
	return true;
}

/**
 * Processes event tickets to set the cheapest ticket as default and ensure attendeeCountPerItem is 1
 * If a default ticket is already set from the backend, it will be preserved
 * Also deduplicates tickets by ID to prevent backend duplication issues
 * Tickets without IDs are preserved (cannot be deduplicated)
 * @param tickets - Array of event tickets from form data
 * @param isClone - When true, removes ticket IDs so backend generates new ones for cloned events
 * @returns Processed tickets with isDefault set correctly and duplicates removed
 */
export function processEventTickets(tickets: Api.IEventTicket[], isClone = false): Api.IEventTicket[] {
	if (tickets.length === 0) return [];

	// Deduplicate tickets by ID (defensive against backend creating duplicates)
	// Preserve tickets without IDs as they can't be deduplicated
	const uniqueTicketsMap = new Map<string, Api.IEventTicket>();
	const ticketsWithoutIds: Api.IEventTicket[] = [];

	tickets.forEach(ticket => {
		if (ticket.id) {
			// Only add if we haven't seen this ID before
			if (!uniqueTicketsMap.has(ticket.id)) {
				uniqueTicketsMap.set(ticket.id, ticket);
			}
		} else {
			// Preserve tickets without IDs
			ticketsWithoutIds.push(ticket);
		}
	});

	const uniqueTickets = [...Array.from(uniqueTicketsMap.values()), ...ticketsWithoutIds];

	// Safety check: should never happen due to empty check at the start, but be defensive
	if (uniqueTickets.length === 0) return [];

	// Check if any ticket already has isDefault set to true
	const hasExistingDefault = uniqueTickets.some(ticket => ticket.isDefault === true);

	if (hasExistingDefault) {
		// Preserve existing default, just ensure attendeeCountPerItem is 1
		return uniqueTickets.map(ticket => {
			// Remove ID for cloned events so backend generates new IDs
			if (isClone) {
				const { id: _, ...processedTicket } = {
					...ticket,
					attendeeCountPerItem: 1,
				};
				return processedTicket;
			}
			return {
				...ticket,
				attendeeCountPerItem: 1,
			};
		});
	}

	// No existing default, find the cheapest ticket (lowest unitPrice)
	// Use the first ticket as the initial value for reduce
	const cheapestTicket = uniqueTickets.reduce(
		(min, ticket) => ((ticket.unitPrice || 0) < (min.unitPrice || 0) ? ticket : min),
		uniqueTickets[0]
	);

	// Map tickets: set cheapest to isDefault: true, others to false, ensure attendeeCountPerItem is 1
	return uniqueTickets.map(ticket => {
		// Remove ID for cloned events so backend generates new IDs
		if (isClone) {
			const { id: _, ...processedTicket } = {
				...ticket,
				// Use reference equality since tickets without IDs can't be compared by ID
				isDefault: ticket === cheapestTicket,
				attendeeCountPerItem: 1,
			};
			return processedTicket;
		}
		return {
			...ticket,
			// Use reference equality since tickets without IDs can't be compared by ID
			isDefault: ticket === cheapestTicket,
			attendeeCountPerItem: 1,
		};
	});
}

/**
 * Given the current field ordering and the modal's reordered list, returns the IDs of fields
 * whose position changed. Computes against the raw reordered list (not a post-filter version)
 * so unknown ids returned by the modal can't shift surviving indices and corrupt the result.
 * Ids returned by the modal that don't exist in the current fields are skipped.
 */
export function computeReorderDirtyIds(
	currentFields: Api.IFormField<string>[],
	reorderedQuestions: { id: string }[]
): string[] {
	const originalIndexMap = new Map(currentFields.map((f, i) => [f.id, i]));
	const dirty: string[] = [];
	reorderedQuestions.forEach((field, newIndex) => {
		const originalIndex = originalIndexMap.get(field.id);
		if (originalIndex !== undefined && originalIndex !== newIndex) {
			dirty.push(field.id);
		}
	});
	return dirty;
}
